// api
import { fetchApi } from '@/api'
import router from '@/router'

const controlaccesoreportslistES = (context, array) => {
  let url = 'admin/reporteES'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesoreportslistPe = (context, array) => {
  let url = 'admin/reportePe'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesoreportsFallos = (context, array) => {
  let url = 'admin/reporteFallos'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_REPORTS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesoreportsaux = (context, array) => true

export default {
  controlaccesoreportslistES,
  controlaccesoreportslistPe,
  controlaccesoreportsaux,
  controlaccesoreportsFallos
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/reports/actions.js